module.exports = __webpack_public_path__ + "assets/img/37_981_big.dc20d042.jpg";